/* Publish by EComposer at 2026-10-19 05:43:11*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8yf7avono6k"]=  window.__ectimmers["ecom-8yf7avono6k"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-8yf7avono6k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8yf7avono6k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-51rdbufpdfo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-51rdbufpdfo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cl309f4rmnp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cl309f4rmnp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s1jhj2wfog').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s1jhj2wfog', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y11iiglmqvp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y11iiglmqvp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jjs1c8zj86c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jjs1c8zj86c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j4190kjcfb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j4190kjcfb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bra6r9jxkjo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bra6r9jxkjo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h9aztlh5rxk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h9aztlh5rxk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fsxdsqzwrju').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fsxdsqzwrju', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-w3v9gsu792c"]=  window.__ectimmers["ecom-w3v9gsu792c"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-w3v9gsu792c"]["ryh4zknwr"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-w3v9gsu792c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w3v9gsu792c', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dzjsgw2xnii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dzjsgw2xnii', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5e3e0pbko2i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5e3e0pbko2i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tkw8quzoh0i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tkw8quzoh0i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-92w322u8zr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-92w322u8zr', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nak032oyp6d"]=  window.__ectimmers["ecom-nak032oyp6d"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-nak032oyp6d"]["ni0xhhto0"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-nak032oyp6d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nak032oyp6d', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8welpa2gqt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8welpa2gqt', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z2gcedslq7g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z2gcedslq7g', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lrbzz2o5xb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lrbzz2o5xb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rhkep1ajzcl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rhkep1ajzcl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l6u7ttzj5w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l6u7ttzj5w', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fciax1s4peu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fciax1s4peu', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m9uwusfkawq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m9uwusfkawq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xxkeq8oq3xd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xxkeq8oq3xd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-klnf9q44c9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-klnf9q44c9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q911lefu3dg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q911lefu3dg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x491hmsixvr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x491hmsixvr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u64gp2twymd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u64gp2twymd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}